<template>
    <b-card :img-src="file.url"
            :img-alt="file.title"
            class="mb-5">
        <slot name="content">
            <p>{{ file.file_name }}</p>
        </slot>
        <template slot="footer">
            <slot name="footer"></slot>
        </template>
    </b-card>
</template>

<script>
    export default {
        props: ['file']
    }
</script>